import { useState } from 'react';

import { MDText } from 'i18n-react';

import { InfoBox } from '@motorway/mw-highway-code/alpha';

import { DOCUMENT_CAPTURE_SNOW_PLOW_EVENTS } from 'Utilities/analytics/analyticsDocumentCapture';
import { applyCypressData } from 'Utilities/index';

import { DOCUMENT_KINDS } from '../DocumentCapture.helpers';
import LocalTexts from '../DocumentCapture.texts.json';
import { useImageManager } from '../uploadDocuments/hooks/useImageManager';

import { usePOARenderControl } from './usePOARenderControl';

import styles from './ProofOfAddressMismatchInfoBox.scss';

const LocalT = new MDText(LocalTexts);

const ProofOfAddressMismatchInfoBox = ({ kind }: { kind: string})
: React.JSX.Element | null => {
  const { hasUploadedDocuments } = useImageManager();
  const [isVisible, setIsVisible] = useState(true);

  const { showErrorBox } = useImageManager();
  const shouldRender = usePOARenderControl(hasUploadedDocuments) && isVisible;

  const content = LocalT.translate('proofOfAddress.content');
  const heading = LocalT.translate('proofOfAddress.heading');
  const info = LocalT.translate('proofOfAddress.variant') as 'info';

  const handleInfoBoxClose = () => {
    DOCUMENT_CAPTURE_SNOW_PLOW_EVENTS.PROOF_OF_ADDRESS_MISMATCH_INFOBOX_CLOSED();
    setIsVisible(!isVisible);
  };

  // add condition here if there is any mismatch between v5c and driving licence
  // and we have boolean coming from the backend
  if (kind === DOCUMENT_KINDS.UTILITY_BILL && shouldRender) {
    return (
      <div className={showErrorBox ? styles.mismatchInfoAndErrorBox : styles.mismatchInfoBox}>
        <InfoBox
          content={content}
          heading={heading}
          onClose={handleInfoBoxClose}
          variant={info}
          {...applyCypressData('poaMismatchInfoBox')} />
      </div>
    );
  }

  return null;
};

export default ProofOfAddressMismatchInfoBox;
